import { runClientComponent } from '../../_common/client/client-component-runner';
import { RecoSponsoredComponent } from './reco-sponsored.component';

runClientComponent({ RecoSponsoredComponent });
